export default __webpack_public_path__ + "static/media/telefooncel.b9678778.svg";